@if (isMobile) {
<div class="mobile-navbar-wrapper">
  <header class="mobile-navbar" [class.menu-open]="menuOpen" role="banner" aria-label="Cabecera Fundación Capgemini">
    <div class="mobile-header">
      <div class="logo" role="img" [style.backgroundImage]="'url(' + logo + ')'"
        [attr.aria-label]="navbar.logo?.ariaLabel ?? 'Logo Fundación Capgemini'"></div>

      <app-button #hamburgerBtn class="hamburger-btn" type="icon-only" variant="tertiary" (clickEvent)="toggleMenu()"
        (keydown)="onHamburgerKeydown($event)" [iconName]="menuOpen ? 'close' : 'menu'"
        [ariaLabel]="menuOpen ? 'Cerrar menú principal' : 'Abrir menú principal'"
        [attr.aria-expanded]="menuOpen ? 'true' : null" [attr.aria-controls]="'mobile-panel'" size="small"></app-button>
    </div>

    @if (menuOpen) {

    <nav #mobilePanel id="mobile-panel" class="mobile-navpanel" role="navigation" aria-label="Menú principal"
      (keydown)="handleKeyDown($event)">

      <div class="mobile-navpanel-content">
        @if (!currentSubmenu) {

        <ul class="menu-root" role="menubar">

          @for (element of elements; track i; let i = $index) {

          <li class="menu-item" role="none">

            @if (element.type === 'dropdown') {

            <app-dropdown-menu [name]="element.placeholder" [placeholder]="element.placeholder" variant="mobile"
              [suggestions]="element.suggestions" (submenuSelected)="openSubmenu($event.title, $event.items)">
            </app-dropdown-menu>

            } @else {

            <app-button-menu [id]="'mobile-button-' + i" [externalLink]="element.isExternal" [label]="element.label"
              [url]="element.url" shape="squared" variant="mobile"
              [selected]="element.url === router.url ? 'selected' : 'notselected'">
            </app-button-menu>

            }

          </li>

          }

        </ul>

        } @else {

        <div class="mobile-submenu">

          <button type="button" class="mobile-submenu-back" (click)="closeSubmenu()">

            <span class="material-symbols-outlined">
              chevron_left
            </span>

            {{ currentSubmenu.title }}

          </button>

          <div class="mobile-submenu-items">

            @for(item of currentSubmenu.items; track item.name) {

            <a class="mobile-submenu-item" [routerLink]="item.url" (click)="toggleMenu()">

              {{ item.name }}

            </a>

            }

          </div>

        </div>

        }
      </div>

      <div class="mobile-navpanel-footer">
        <img [src]="imageUtils.getImageUrl(navbar.dropdownImage?.image?.url ?? '')" alt="Dropdown Image">
      </div>

    </nav>

    }
  </header>
</div>
} @else {
<header class="container" role="banner" aria-label="Cabecera Fundación Capgemini">
  <div class="inner-container">
    <div class="navbar-left">
      <a routerLink="/">
        <div class="logo" role="img" [style.backgroundImage]="'url(' + logo + ')'"
          [attr.aria-label]="navbar.logo?.ariaLabel ?? 'Logo Fundación Capgemini'"></div>
      </a>
    </div>

    <nav role="navigation" aria-label="Menú principal">
      <ul class="navbar-center">
        @for (element of elements; track $index; let i = $index) {
        <ng-container>
          @if (element.type === 'dropdown') {
          <li>
            <app-dropdown-menu [name]="element.placeholder" id="{{ 'dropdown-menu' + element.placeholder + i }}"
              [placeholder]="element.placeholder" variant="header" [suggestions]="element.suggestions"
              [dropdownImage]="imageUtils.getImageUrl(navbar.dropdownImage?.image?.url ?? '')"
              [selected]="isDropdownSelected(element.suggestions)"></app-dropdown-menu>
          </li>
          } @else if (element.type === 'button') {
          <li>
            <app-button-menu [id]="'dropdown-button' + (element.label || '') + i" [externalLink]="element.isExternal"
              [label]="element.label" [url]="element.url" shape="squared" variant="header"
              [selected]="element.url === router.url ? 'selected' : 'notselected'"></app-button-menu>
          </li>
          }
        </ng-container>
        }
      </ul>
    </nav>
  </div>

  <div class="navbar-right">
    @if (navbar.button) {
    <app-button-link [strapiButtonLink]="navbar.button" size="small" materialIconSize="msmall" hidden></app-button-link>
    }
  </div>
</header>

<div class="divider"></div>
}